class IngredientsPageTags extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tagsContainer = this.querySelector("#ingredients-page-tags");
    this.showAllButton = this.querySelector(
      `.ingredients-button[data-tag="all"]`
    );
    this.tagsContainer.addEventListener(
      "click",
      this.handleTagClick.bind(this)
    );
  }

  disconnectedCallback() {
    this.tagsContainer.removeEventListener(
      "click",
      this.handleTagClick.bind(this)
    );
  }

  handleTagClick(event) {
    const btn = event.target.closest(".ingredients-button");
    if (!btn) return;
    const { tag } = btn.dataset;
    if (tag === "all") {
      this.resetElements();
      return;
    }
    this.showAllButton.classList.remove("active");
    btn.classList.toggle("active");
    this.filterProductCards();
  }

  filterProductCards() {
    const activeTags = this.getActiveTags();
    if (activeTags.length === 0) {
      this.resetElements();
      return;
    }
    const activeTagsArray = activeTags.map((tag) => tag.dataset.tag);

    this.querySelectorAll("product-card").forEach((item) => {
      let itemTags = item.dataset.tags;
      let hasTags = this.checkIfItemHasTags(itemTags, activeTagsArray);
      item.dataset.visible = hasTags;
      item.filterProductCardContent(activeTagsArray);
    });
  }

  checkIfItemHasTags(itemTags, activeTagsArray) {
    return activeTagsArray.some((activeTag) => {
      return itemTags.split("::").includes(activeTag);
    });
  }

  getActiveTags() {
    return Array.from(
      this.tagsContainer.querySelectorAll(".ingredients-button.active")
    );
  }

  resetElements() {
    this.tagsContainer
      .querySelectorAll(".ingredients-button")
      .forEach((button) => {
        button.classList.remove("active");
      });

    this.querySelectorAll("product-card").forEach((item) => {
      item.dataset.visible = true;
      item.resetDefaultContent();
    });
    this.showAllButton.classList.add("active");
  }
}
customElements.define("ingredients-page-tags", IngredientsPageTags);

class ProductCard extends IngredientsPageTags {
  constructor() {
    super();
  }

  // Event when component is added to the DOM
  connectedCallback() {
    this.variantSelectors = this.querySelector(
      ".product-card-variant-selectors"
    );

    this.variantSelectorButtons = this.variantSelectors
      ? Array.from(
          this.variantSelectors.querySelectorAll("button.ingredients-button")
        )
      : [];

    this.productCardContentArray = Array.from(
      this.querySelectorAll(".product-card-content")
    );

    this.variantSelectors?.addEventListener(
      "click",
      this.toggleVariantContent.bind(this)
    );
  }

  // Event when component is removed from DOM
  disconnectedCallback() {
    this.variantSelectors.removeEventListener(
      "click",
      this.toggleVariantContent.bind(this)
    );
  }

  filterProductCardContent(activeTagsArray) {
    if (!this.variantSelectors) return;

    this.variantSelectorButtons.forEach((item) => {
      let hasTags = this.checkIfItemHasTags(item.dataset.tags, activeTagsArray);
      item.classList[hasTags ? "add" : "remove"]("active");
    });

    this.productCardContentArray.forEach((item) => {
      let hasTags = this.checkIfItemHasTags(item.dataset.tags, activeTagsArray);
      item.dataset.showVariantInfo = hasTags;
    });
  }

  resetDefaultContent() {
    if (!this.variantSelectors) return;

    this.variantSelectorButtons.forEach((item) => {
      item.classList.remove("active");
    });

    this.productCardContentArray.forEach((item) => {
      item.dataset.showVariantInfo = false;
    });

    this.variantSelectorButtons[0].classList.add("active");
    this.productCardContentArray[0].dataset.showVariantInfo = true;
  }

  /**
   * Toggle the variant content based on the button clicked
   * @param {Event} event
   */
  toggleVariantContent(event) {
    // Getting data attribute from the button
    const btn = event.target.closest(".ingredients-button");
    if (!btn) return;
    const { handle } = btn.dataset;

    // Removing active class from previous active buttons
    this.querySelector(
      `.product-card-content[data-show-variant-info="true"]`
    ).dataset.showVariantInfo = false;
    this.variantSelectors
      .querySelector("button.ingredients-button.active")
      .classList.remove("active");

    // Adding active class to the clicked button
    btn.classList.add("active");
    this.querySelector(
      `.product-card-content[data-handle="${handle}"]`
    ).dataset.showVariantInfo = true;
  }
}
customElements.define("product-card", ProductCard);
